import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import id from "./locales/id.json";
import en from "./locales/en.json";

let savedLanguage = "en";

try {
  const storedLanguage = localStorage.getItem("gloo.language");
  if (storedLanguage === "id" || storedLanguage === "en") {
    savedLanguage = storedLanguage;
  }
} catch {
  // Default to English if browser storage is unavailable.
}

i18n.use(initReactI18next).init({
  resources: {
    id: { translation: id },
    en: { translation: en }
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false
  }
});

export default i18n;
